import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    eventDate: translate({ id: 'gps.eventslist.view.eventDate' }),
  }))

  return api
}
